import "../../../style/GeneralStyle.css";
import "../../../style/PhotoGeneralPage/PhotoGeneralPage.css";
import "../../../../common/UI/PhotoCircle/styles/photocircle.css";

import { useEffect, useState } from "react";
import { PhotoModalSecond } from "../../../../common/UI/Modal/molecules/ModalPhoto";
import { NavMenuMontronix } from "../../../../common/UI/NavMenu/organoids/NavMenuMontronix";
import {
  $GuideMode,
  $ReadenPhotoSlides,
  AddReadenPhotoSlide,
  setOpenVideo,
  setvideoChoise,
} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import { useStore } from "effector-react";
import { GuideButtons } from "../../../../common/UI/GuideButtons/organoids/GuideButtons";
import { IForModal } from "../../../../common/interfaces";
import { points2 } from "../atoms/PhotoPoints";
import { titleName } from "../../../../common/function";

import MAIN4 from "../../../../common/assets/images/Montronix/Photo/Станок_Защита.jpg";
import connorLogo from "../../../../common/assets/images/Montronix/Photo/CEPR.png";
import Circle1 from "../../../../common/assets/images/Montronix/Photo/Сircle.png";
import { Tooltip } from "@mui/material";

export const PhotoPageMontronix = () => {
  const [modalActiveSecond, setModalActiveSecond] = useState(false);
  const [spreadMenu, setSpreadMenu] = useState(false);
  const readenPhotos = useStore($ReadenPhotoSlides);
  const allPoints = points2;
  const [forModal, setForModal] = useState<IForModal>({
    title: "",
    content: [""],
    text: [""],
    titletext: [""],
    list: [{ title: "", quotes: [""] }],
  });

  titleName("Montronix");

  setvideoChoise(0);

  function detectMob() {
    return window.innerWidth <= 800 || window.innerHeight <= 600;
  }

  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  useEffect(() => {
    if ($GuideMode.getState()) {
      if (readenPhotos === 8) {
        setOpenVideo(true);
      }
    }
  }, [readenPhotos]);

  return (
    <div className="PhotoPage">
      <img src={connorLogo} alt="" className="PhotoPage_Logo" />
      <div className="PhotoPage_Block">
        <div className="Page_BlockTitlePhone Page_BlockTitle">
          Нештатные ситуации на оборудование
        </div>
        <div className="PhotoPageMontronix_BlockSecond">
          <div
            className={
              spreadMenu
                ? "PhotoPage_BlockSecond_spreadMenu_One"
                : "PhotoPage_BlockSecond_spreadMenu_Two"
            }
          >
            <img src={MAIN4} className="PhotoPage_BlockSecond_img" alt="" />
            {allPoints.slice(0, readenPhotos + 1).map((e, i) => {
              return !iOS() ? (
                <Tooltip
                  title={!detectMob() ? e.title : ""}
                  key={i}
                  children={
                    <div
                      className="lastVariantButton"
                      onClick={() => {
                        setForModal({
                          title: e.title,
                          content: e.content,
                          text: e.text,
                          list: e.list,
                          damage: e.damage,
                          titletext: e.titletext,
                        });
                        setModalActiveSecond(true);
                        AddReadenPhotoSlide();
                      }}
                      style={{ top: e.top, left: e.left }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          zIndex: 2,
                          textAlign: "center",
                          color: "white",
                          left: "0",
                          right: "0",
                          fontWeight: 700,
                        }}
                      >
                        {e.id}
                      </span>
                      <img
                        className="withWaves"
                        style={{ height: "auto", width: "100%" }}
                        alt=""
                        src={Circle1}
                      ></img>
                    </div>
                  }
                />
              ) : (
                <div
                  className="lastVariantButton"
                  onClick={() => {
                    setForModal({
                      title: e.title,
                      content: e.content,
                      text: e.text,
                      list: e.list,
                      damage: e.damage,
                      titletext: e.titletext,
                    });
                    setModalActiveSecond(true);
                    AddReadenPhotoSlide();
                  }}
                  style={{ top: e.top, left: e.left }}
                >
                  <span
                    style={{
                      position: "absolute",
                      zIndex: 2,
                      textAlign: "center",
                      color: "white",
                      left: "0",
                      right: "0",
                      fontWeight: 700,
                    }}
                  >
                    {e.id}
                  </span>
                  <img
                    className="withWaves"
                    style={{ height: "auto", width: "100%" }}
                    alt=""
                    src={Circle1}
                  ></img>
                </div>
              );
            })}
          </div>
        </div>
        <GuideButtons
          spreadMenu={spreadMenu}
          setSpreadMenu={setSpreadMenu}
          ReadenMarkers={readenPhotos}
          AddReadenMarker={AddReadenPhotoSlide}
          markers={points2}
          setForModal={setForModal}
          setModalActive={setModalActiveSecond}
        />
        <NavMenuMontronix
          nextUrl={"/montronix/video"}
          backUrl={"/montronix"}
          visibleFlag={"/montronix/photo"}
        />
      </div>
      <PhotoModalSecond
        text={forModal.text}
        title={forModal.title}
        content={forModal.content}
        active={modalActiveSecond}
        setActive={setModalActiveSecond}
        list={forModal.list}
        damage={forModal.damage}
      />
    </div>
  );
};
